<script>
  import recuperarSenhaAlunoServico from './servico';

  export default {
    data() {
      return {
        usuario: {},
        mostrarErro: false,
        configuracao: this.$storage.configuracao(),
        mensagemErroUsuario: '',
        enviando: false,
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.recuperarSenha()
        }
      },
      retornaCaminhoVoltar() {
        return 'login.aluno';       
      },
      recuperarSenha: function () {
        this.mostrarErro = false;
        this.enviando = true;

        recuperarSenhaAlunoServico.recuperarAluno(this.usuario)
          .then(resposta => {
            this.$swal('', 'Senha enviada com sucesso para o email ' + resposta.body.email, 'info');

            this.$router.push('/login/aluno');
          })
          .catch(erro => {
            this.enviando = false;

            if (erro.status === 404) {
              this.mostrarErro = true;
              this.mensagemErroUsuario = 'Aluno não encontrado, entre em contato com a fundação.';
            } else {
              if (erro.status === 422) {
                this.mensagemErroUsuario = erro.body.message;

                this.mostrarErro = true;
              } else {
                this.$swal('', 'Ocorreu um erro ao recuperar senha, caso o erro persista entre em contato com a fundação.', 'error');
              }
            }
          });
      }
    },
    computed: {
    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErro">{{ mensagemErroUsuario }}</div>

      <div class="form-group" :class="{ 'has-error': errors.has('CPF') }">
        <input type="text"
               class="form-control"
               placeholder="CPF"
               name="CPF"
               id="cpf"
               v-model="usuario.login"
               v-validate="'required'"
               v-mascara="'cpf'">

        <p class="text-danger" v-if="errors.has('CNPJ')">{{ errors.first('CPF') }}</p>
      </div>

      <div slot="form-group" class="form-group">
        <router-link class="btn btn-default"
                     style="margin-bottom: 5px;width:140px;"
                     :disabled="enviando"
                     data-loading-text="<i class='fa fa-arrow-left'></i> Voltar"
                     :to='{ name: retornaCaminhoVoltar() }'>
          <i class="fa fa-arrow-left"></i>
          Voltar
        </router-link>

        <button type="button"
                class="btn btn-primary"
                :disabled="enviando"
                style="margin-bottom: 5px;width:140px;"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Enviando..."
                @click="validar">
          <i class="fa fa-check"></i> Enviar
        </button>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/recuperar-senha-aluno/RecuperarSenhaAluno.vue